<template>
    <div>
        <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item" v-for="c in $i18n.messages[$i18n.locale].tab.itemFormTabs" :key="c.id">
                <a :class="{'active': selectedTab == c.id}" class="nav-link" role="tab" @click="selectedTab = c.id">{{c.text}}</a>
            </li>
        </ul>
        <form @submit.prevent="submitFormData">
            <div class="tab-content">
                <div :class="{'active': selectedTab == 'details'}" class="tab-pane mt-3">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 border-right">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.title')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-text"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.title')" v-model="title" required="">
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.price')}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.price')" @keypress="isNumber($event)" v-model="price" required="">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-6">
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.base_price')}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-dollar-sign"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.base_price')" @keypress="isNumber($event)" v-model="basePrice" required="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{$t('label.category')}}</label>
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-tag"></i>
                                        </label>
                                        <multiselect 
                                            :value="selectedCategory" 
                                            :options="categories" 
                                            label="text" track-by="id" 
                                            :searchable="false" 
                                            :show-labels="false" 
                                            openDirection="below" 
                                            @select="filterSubCatByCategory">
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{$t('label.subcategory')}}</label>
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-tags"></i>
                                        </label>
                                        <multiselect 
                                            :value="selectedSubcategory" 
                                            :options="subCategory" 
                                            track-by="id" label="text" 
                                            :show-labels="false" 
                                            openDirection="below" 
                                            @select="selectSubcategory">
                                            <span slot="noResult">{{$t('table.no_records')}}</span>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{$t('label.duration')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-clock"></i>
                                        </span>
                                    </div>
                                    <vue-timepicker class="form-control bg-transparent" :format="'H hr mm Min'" :hide-disabled-hours="true" :hour-range="hourRange" :minute-range="minRange" :minute-interval="15" v-model="duration" @change="setTimePicker"></vue-timepicker>
                                </div>
                                <div id="err" class="error-validation"></div>
                            </div>
                            <div class="form-group mb-2">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="editServiceEnable" v-model="enable">
                                    <label class="custom-control-label" for="editServiceEnable">{{$t('label.enable')}}</label>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="custom-control custom-switch">
                                    <input type="checkbox" class="custom-control-input" id="editServiceOnline" v-model="online">
                                    <label class="custom-control-label" for="editServiceOnline">{{$t('label.online')}}</label>
                                </div>
                            </div>   
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <h6 class="text-dark fw-500">{{$t('table.header.image')}}:</h6>
                            <div id="imageContainer" v-if="image != ''" class="text-center mt-3">
                                <div class="text-right mb-2 mr-2">
                                    <button v-show="!dzShow" class="btn btn-sm btn-outline-primary" type="button" :title="$t('header.delete_image')" @click="showModal">
                                        <span class="fal fa-trash" ></span>
                                    </button>
                                </div>
                                <a @click="handleDropzone('img-thumbnail')" :title="$t('button_link.click_upload')" class="m-auto">
                                    <img class="img-fluid img-thumbnail" :src="image"/>
                                </a>
                            </div>
                            <div v-else>
                                <vue-dropzone ref="dropzone" class="text-center" id="dropLogo" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
                            </div>
                            <div v-if="dzShow" class="mt-2"> 
                                <div class="row">
                                    <div class="col">
                                        <h6 class="text-dark fs-sm">{{$t('header.upload_image')}}: </h6>
                                    </div>
                                    <div class="col text-right">
                                        <a id="uploadCancel" class="cancel link" @click="handleDropzone('item-image')">{{$t('button_link.cancel')}}</a>
                                    </div>
                                </div>
                                <vue-dropzone ref="dropzone" class="text-center" id="dropLogo" :options="dropOptions" @vdropzone-success="dropLogo"></vue-dropzone>
                            </div>
                        </div>
                    </div>
                </div>  
                <div :class="{'active': selectedTab == 'policy'}" class="tab-pane mt-3">
                    <template>
                        <vue-editor v-model="content" />
                    </template>
                </div>
            </div>
            <div class="border-top pt-3 mt-3 mb-3">
                <div class="row">
                    <div class="col-6">
                        <button v-if="!isEdit" type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnServiceList">{{$t('button_link.cancel')}}</button>
                        <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                    </div>
                    <div class="d-none col-6 text-right">
                        <button v-if="isEdit" type="button" class="btn border-0 btn-danger btn-padding waves-effect waves-themed" @click="deleteService">Delete</button>
                    </div>
                </div>
            </div>
        </form>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteImage"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import vueDropzone from "vue2-dropzone";
import { VueEditor } from "vue2-editor";
import VueTimepicker from 'vue2-timepicker'
import {setCategoryLabel, getCategoryText, getSubcategory, handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import {convertToMin, formFormatTime, isNumber, getMessage} from './../../../../assets/js/dashboard/utilities'

export default {
    name: 'serviceForm',
    props:{
       isEdit: { type: Boolean },
       category: { type: Array },
   },
   components:{
       VueTimepicker, VueEditor, vueDropzone, DeleteModal
   },
   data(){
       return{
            type: "service",
            selectedTab: "details",
            hourRange: [], minRange: [], image: "", addImagePath: "",
            itemID: 0, title: "", price: 0, basePrice: 0, selectedCategory: 0, duration:"", enable: 1, online: 0,
            categories: [], subCategories: [],
            subCategory: [], selectedSubcategory: {}, 
            content: "",
            dzShow: false,
            dropOptions: {
                url: this.$api.API_IMAGE,
                addRemoveLinks: true,
                maxFiles: 1,
                paramName: 'filename',
                headers:{
                    token: this.$util.getSessionToken()
                }
            },

            defaultSubcategory: {},
       }
   },
   watch:{
        "$i18n.locale"(val){
            this.subCategory = this.setLabel(this.subCategories)
            
            var b = Object.assign({}, this.selectedSubcategory)
            this.selectedSubcategory = this.subCategory.filter(obj=> obj.id == b.id)[0]
        }
    },
   methods:{
        setDefaultCategory(categoryValue, subcategoryValue) {
            if(categoryValue !== 'all') {
                for(let category of this.categories) {
                    if(category.id === categoryValue) {
                        this.selectedCategory = category
                    }
                }
            }

            this.selectedCategory = this.selectedCategory || this.categories[0]

            this.defaultSubcategory = subcategoryValue
            this.filterSubCatByCategory(this.selectedCategory)
        },

       isNumber(e){
            return isNumber(e);
        },
        setTimePicker(e){
           if(e.data.H != "0"){
               this.minRange = []
               for(var i=0; i<4; i++){
                   this.minRange.push(i*15)
               }
           }else{
                this.minRange = []
                for(var j=1; j<4; j++){
                    this.minRange.push(j*15)
                }
           }
           document.getElementById('err').innerHTML = null;
        },
        closeModal(isError){
            if(!isError){
                if(this.$refs.deleteModal.toggleModal){
                    this.$refs.deleteModal.toggleModal = false
                    this.$emit('renderService')
                }else if(this.dzShow){
                    this.$emit('renderService')
                    this.dzShow = false
                }else{
                    this.returnServiceList()
                }
            }
            
            this.$parent.$parent.$parent.isModalShow = false
        },
        dropLogo(file, response){
            if(response.path == undefined){
                this.parent.$parent.$parent.setModal(this, false, true, this.$i18n.t('message.error.upload'));
            }

            if(this.isEdit){
                var data = this.setFormData()
                data.image = response.path
                this.image = response.path
                this.submitForm(data, false, false)
                this.$refs.dropzone.removeFile(file)
            }else{
                this.addImagePath = response.path
            }
            this.dzShow = true
        },
        setFormData(){
            var duration = this.duration.H + " hr " + this.duration.mm + " Min"
            var data = {
                itemID: this.itemID,
                type: this.type,
                title: this.title,
                category: this.selectedCategory.id,    
                price: this.price,
                basePrice: this.basePrice,
                duration: convertToMin(duration),
                folderID: this.selectedSubcategory.id == 0 ? "" : this.selectedSubcategory.id,
                isEnable: this.enable ? 1 : 0,
                showOnline: this.online ? '1' : '0'
            }
            return data
        },
        submitFormData(){
            var data = this.setFormData()

            if(!this.isEdit){
                data.image = this.addImagePath
            }
            if(this.duration.H == "0" && this.duration.mm == "00"){
                document.getElementById('err').innerHTML = this.$i18n.t('message.error.duration');
            }else this.submitForm(data, true, false)
        },
        handleDropzone(strClass){
            var parent = document.getElementById("imageContainer");
            const imgs = parent.getElementsByClassName(strClass)
            
            var j = 0;
            if(imgs.length > 0){
                for(var i=0; i<imgs.length;){
                    var img = imgs[i];
                    var link = img.parentElement;

                    if(img.classList.contains('img-thumbnail')){
                        img.classList.remove('img-thumbnail');
                        img.classList.add('item-image');

                        link.classList.remove('m-auto');
                        link.classList.add('mr-2');
                        link.setAttribute('title', '');
                        parent.classList.add('d-flex');

                        this.dzShow = true;
                    }else{
                        img.classList.add('img-thumbnail');
                        img.classList.remove('item-image');

                        link.classList.add('m-auto');
                        link.classList.remove('mr-2');
                        link.setAttribute('title', this.$i18n.t('button_link.click_upload'));
                        parent.classList.remove('d-flex')

                        this.dzShow = false;
                    }
                    j++;
                }
            }
        },
        setCategoryOptions(){
            this.categories = this.category.slice(1, this.category.length)
            this.selectedCategory = this.categories[0]
        },
        async filterSubCatByCategory(item){
            this.selectedCategory = item;
            var strFilter = "?category=" + item.id;
            this.subCategories = await getSubcategory(this, "", strFilter);

            this.subCategory = this.setLabel(this.subCategories)
            this.selectedSubcategory = this.subCategory[0]

            if(this.defaultSubcategory) {
                for(let subcategory of this.subCategory) {
                    if(subcategory['id'] === this.defaultSubcategory) {
                        this.selectedSubcategory = subcategory
                    }
                }
                this.defaultSubcategory = null
            }
        },
        selectSubcategory(item){
            this.selectedSubcategory  = {}
            this.selectedSubcategory = item;
        },
        async editServiceForm(item, category){
            this.setCategoryOptions()
            await this.filterSubCatByCategory({id: item.category});

            this.itemID = item.itemID;
            this.title = item.title;
            this.price = parseFloat(item.price).toFixed(2);
            this.basePrice = parseFloat(item.basePrice).toFixed(2);
            this.selectedCategory = {id: item.category, text: getCategoryText(item.category, category)};
            this.selectedSubcategory = {id: item.folderID == "" ? "" : parseInt(item.folderID), text: item.folderID == "" ? this.$i18n.t('label.no_subCategory') : getCategoryText(item.folderID, this.subCategory)};
            this.duration = formFormatTime(parseInt(item.duration));
            this.enable = item.isEnable;
            this.online = item.showOnline == '1' ? true : false;
            this.image = item.image

            var policy = await this.getItemPolicy(this.itemID)
            this.content = policy.policy
        },
        showModal(){
            var title = this.$i18n.t('header.delete_image')
            var message = this.$i18n.t('message.confirmation.delete_image')
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteImage(){
            var data = this.setFormData()
            data.image = ""
            this.submitForm(data, false, true)
        },
        returnServiceList(){
            this.$emit('returnServiceList');
        },
        async submitForm(data, isFormData, isDeleteImage){
            // await this.submitItemPolicy()
            // if(await this.submitItemPolicy()){
            //     this.$emit('submitForm', data);
            // }
            let _url = this.$api.MENU_ITEM
            let url = this.isEdit ?  _url + "/" + data.itemID + this.$api.UPDATE : _url

            let $vm = this
            $vm.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    var action = $vm.isEdit ? $vm.$i18n.t('message.success.action.update') : $vm.$i18n.t('message.success.action.add')
                    var retData = response.data;
                    var message = isFormData ? "'" + retData.title + "' " + $vm.$i18n.t('message.success.success', {'action': action}) : (isDeleteImage ? $vm.$i18n.t('message.success.delete_image') : $vm.$i18n.t('message.success.upload'))
                    $vm.$parent.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.$parent.$parent.setModal($vm, true, true,  $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        deleteService(){
            this.$emit('deleteService', this.itemID, this.title)
        },
        async getItemPolicy(id){
            let $vm = this;
            let QUERY_STRING =  "/" + id + this.$api.ITEM_POLICY
            const url =  this.$api.MENU_ITEM + QUERY_STRING;
            
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result[0]
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return result;
        },
        async submitItemPolicy(){
            let $vm = this
            let QUERY_STRING =  "/" + this.itemID + this.$api.ITEM_POLICY
            const url =  this.$api.MENU_ITEM + QUERY_STRING;
            
            var status = false
            await this.$axios({
                method: 'post', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: {
                    policy: this.content
                }
            })
            .then((response) => {
                if(response.status == 200){
                    status = true
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return status
        },
        setLabel(item){
            return setCategoryLabel(this, false, this.$i18n.t('label.no_subCategory'), item)
        },
    },
    async mounted(){
        let $vm = this;
        $vm.setCategoryOptions();
        
        // $vm.subCategories = await getSubcategory($vm, "", "?category=0");
        // $vm.subCategory = $vm.setLabel($vm.subCategories)
        // $vm.selectedSubcategory = $vm.subCategory[0]

        // if(this.subcategoryDefault) {
        //     if(this.subCategory && this.subCategory.length > 0) {
        //         for(let subcategory of this.subCategory) {
        //             if(subcategory['id'] === this.defaultSubcategory) {
        //                 this.selectedSubcategory = subcategory
        //                 break
        //             }
        //         }
        //     }
        // }

        $vm.duration = {
        "H": "0",
        "mm": "30",
        }

        for(var i=1; i<4; i++){
            $vm.minRange.push(i*15);
        }
        for(var j=0; j<10; j++){
            $vm.hourRange.push(j);
        }
    }
}
</script>
<style scoped>
.show{
    display: block;
}
.nav-link, .link{
    cursor: pointer;
}
.img-thumbnail{
    width: 20em;
}
.item-image{
    width: 8em;
    opacity: .5;
}
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>